export default __webpack_public_path__ + "assets/_Chapters/CTeileSortiment/Arbeitsschutz/3m.png";